import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} ホーム`,
    languageButtonLabel: `言語`,
    languageModalTitle: `言語を選ぶ`,
    languageModalCloseLabel: `言語メニューを閉じる`,
  },
  languageOptions: {
    'en-US': {
      label: `英語`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英語（ケニア）`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英語（ナイジェリア）`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英語 (シンガポール)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `ポルトガル語`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `ドイツ語`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `スペイン語`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `フランス語`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `イタリア語`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `オランダ語`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `北欧・バルト語`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日本語`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韓国語`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `標準中国語`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `広東語`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `タイ語`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `ヒンディー語`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `ペルシア語`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `ロシア語`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `アラビア語`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `モロッコ・アラビア語`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `言語を選ぶ`,
    closeLabel: `言語メニューを閉じる`,
  },
  languageHint: (ctx) => `ワンタップで ${ctx.localesCount}+ 言語へジャンプ。`,
  readPagePrompt: ({languageLabel}) => `${languageLabel}でこのページを読む。`,
};
